import React from 'react'
import { connect } from 'react-redux'
import { driveSidebarSelector } from 'selectors'
import { getProfilePhoto } from 'util/profile'
import Sidebar, { NameHeading, NameSubHeading, Section, SidebarLink, SidebarExternalLink } from './Sidebar'
import { Link } from 'react-router-dom'
import StarRating from 'components/misc/StarRating'
import Avatar from 'rui/widgets/Avatar'
import { LocalizedText } from 'localization'
import { FeatureFlag } from 'Optimizely'

const DriveSidebarWithoutRouter: React.FC<{
  // TODO: create types for these props
  prop22EarningsStatement?: any[]
  nycEarningsStatement?: any[]
  isLocked: boolean
  profile: any
  seattleDriver: any
}> = (props) => {
  const { prop22EarningsStatement, nycEarningsStatement, isLocked, profile, seattleDriver } = props
  const signupDate = profile.member_since.split('-')[0]

  const showEarningsStatementLink = Boolean(
    (prop22EarningsStatement && prop22EarningsStatement.length) || (nycEarningsStatement && nycEarningsStatement.length)
  )
  const languagePreferenceLink = (
    <SidebarLink
      id="sidebar-link-to-language-preference"
      to="/account/language-preference"
      data-cy="sidebar-language-preference-link"
    >
      <LocalizedText translationKey="dweb_common_language_preference" />
    </SidebarLink>
  )

  return (
    <Sidebar>
      <Section>
        <Link id="sidebar-link-to-dashboard" to="dashboard" data-cy="sidebar-dashboard-link">
          <Avatar size="80" url={getProfilePhoto(profile)} />
          <NameHeading>
            {profile.first_name} {profile.last_name}
          </NameHeading>
          <NameSubHeading>
            <LocalizedText translationKey="dweb_common_driver_since_date" params={{ signupDate }} />
          </NameSubHeading>
          <StarRating rating={profile.average_rating} ratingCount={profile.rating_count} />
        </Link>
      </Section>

      <Section>
        <SidebarLink id="sidebar-link-to-gig-history" to="/gig-history" data-cy="sidebar-gig-history-link">
          <LocalizedText translationKey="dweb_layout_drive_sidebar_gig_history" />
        </SidebarLink>
        <SidebarLink id="sidebar-link-to-tax-information" to="/tax-information" data-cy="sidebar-tax-information-link">
          <LocalizedText translationKey="dweb_common_tax_information" />
        </SidebarLink>
        {showEarningsStatementLink ? (
          <SidebarLink
            id="sidebar-link-to-earnings-statement"
            to="/earnings-statement"
            data-cy="sidebar-earnings-statement-link"
          >
            <LocalizedText translationKey="dweb_common_earnings_statements" />
          </SidebarLink>
        ) : null}
        {seattleDriver ? (
          <SidebarLink
            id="sidebar-link-to-seattle-dashboard"
            to="/seattle-dashboard"
            data-cy="sidebar-seattle-dashboard-link"
          >
            <LocalizedText translationKey="dweb_layout_drive_sidebar_seattle_driver_dashboard" />
          </SidebarLink>
        ) : null}
      </Section>
      {!isLocked && (
        <Section>
          <h4>
            <LocalizedText translationKey="dweb_layout_drive_sidebar_road" />
          </h4>
          <SidebarLink id="sidebar-link-to-how-tos" to="/how-tos" data-cy="sidebar-how-tos-link">
            <LocalizedText translationKey="dweb_layout_drive_sidebar_how_tos" />
          </SidebarLink>
          <SidebarLink id="sidebar-link-to-promotions" to="/promotions" data-cy="sidebar-promotions-link">
            <LocalizedText translationKey="dweb_layout_drive_sidebar_promotions" />
          </SidebarLink>
        </Section>
      )}
      <Section>
        <h4>
          <LocalizedText translationKey="dweb_layout_drive_sidebar_my_account" />
        </h4>
        <SidebarLink id="sidebar-link-to-bio" to="/account/bio" data-cy="sidebar-photo-bio-link">
          <LocalizedText translationKey="dweb_layout_drive_sidebar_photo_bio" />
        </SidebarLink>
        <SidebarLink id="sidebar-link-to-basic-info" to="/account/basic-info" data-cy="sidebar-basic-info-link">
          <LocalizedText translationKey="dweb_layout_drive_sidebar_basic_info" />
        </SidebarLink>
        <SidebarLink id="sidebar-link-to-driving-info" to="/account/driving-info" data-cy="sidebar-driving-info-link">
          <LocalizedText translationKey="dweb_common_driving_info" />
        </SidebarLink>
        <SidebarLink id="sidebar-link-to-bank-info" to="/account/bank-info" data-cy="sidebar-payment-info-link">
          <LocalizedText translationKey="dweb_layout_drive_sidebar_payment_info" />
        </SidebarLink>
        <SidebarLink id="sidebar-link-to-contact-info" to="/account/contact-info" data-cy="sidebar-email-phone-link">
          <LocalizedText translationKey="dweb_layout_drive_sidebar_email_phone" />
        </SidebarLink>
        <SidebarLink id="sidebar-link-to-password" to="/account/password" data-cy="sidebar-password-link">
          <LocalizedText translationKey="dweb_common_password" />
        </SidebarLink>
      </Section>

      <Section>
        {seattleDriver ? (
          languagePreferenceLink
        ) : (
          <FeatureFlag feature="drive_language_preference_access">{languagePreferenceLink}</FeatureFlag>
        )}
        <SidebarLink
          id="sidebar-link-to-privacy-setting"
          to="/account/privacy-settings"
          data-cy="sidebar-privacy-settings-link"
        >
          <LocalizedText translationKey="dweb_layout_drive_sidebar_privacy_settings" />
        </SidebarLink>
      </Section>

      <Section>
        <SidebarExternalLink
          id="sidebar-link-to-support"
          href={`${import.meta.env.REACT_APP_SUPPORT_URL}/support/s/contactsupport`}
          data-cy="sidebar-email-support-link"
        >
          <LocalizedText translationKey="dweb_layout_drive_sidebar_email_support" />
        </SidebarExternalLink>
      </Section>
    </Sidebar>
  )
}

const DriveSidebar = connect(driveSidebarSelector)(DriveSidebarWithoutRouter)

export default DriveSidebar
